function SvgGradient() {
  var black1 = '#141414'
  var black2 = '#262623'
  var black3 = '#2D3436'

  var light1 = '#302e21'

  var listOfColors1 = `${black1};${black2};${black3};${light1};${black1}`
  var listOfColors2 = `${black2};${black3};${light1};${black1};${black2}`
  var listOfColors3 = `${black3};${light1};${black1};${black2};${black3}`

  var duration = 10
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' className='svg-background'>
        <defs>
          <linearGradient
            id='a'
            gradientUnits='objectBoundingBox'
            x1='0'
            y1='0'
            x2='1'
            y2='1'
          >
            <stop offset='0' stopColor={black1}>
              <animate
                attributeName='stop-color'
                values={listOfColors1}
                dur={duration}
                repeatCount='indefinite'
              ></animate>
            </stop>
            <stop offset='.5' stopColor={black2}>
              <animate
                attributeName='stop-color'
                values={listOfColors2}
                dur={duration}
                repeatCount='indefinite'
              ></animate>
            </stop>
            <stop offset='1' stopColor={black3}>
              <animate
                attributeName='stop-color'
                values={listOfColors3}
                dur={duration}
                repeatCount='indefinite'
              ></animate>
            </stop>
            <animateTransform
              attributeName='gradientTransform'
              type='rotate'
              from='0 .5 .5'
              to='360 .5 .5'
              dur={duration}
              repeatCount='indefinite'
            />
          </linearGradient>
          <linearGradient
            id='b'
            gradientUnits='objectBoundingBox'
            x1='0'
            y1='1'
            x2='1'
            y2='1'
          >
            <stop offset='0' stopColor={black1}>
              <animate
                attributeName='stop-color'
                values={listOfColors1}
                dur={duration}
                repeatCount='indefinite'
              ></animate>
            </stop>
            <stop offset='1' stopColor={light1} stopOpacity='0'>
              <animate
                attributeName='stop-color'
                values={listOfColors3}
                dur={duration}
                repeatCount='indefinite'
              ></animate>
            </stop>
            <animateTransform
              attributeName='gradientTransform'
              type='rotate'
              values='360 .5 .5;0 .5 .5'
              className='ignore'
              dur={duration}
              repeatCount='indefinite'
            />
          </linearGradient>
        </defs>
        <rect fill='url(#a)' width='100%' height='100%' />
        <rect fill='url(#b)' width='100%' height='100%' />
      </svg>
    </>
  )
}

export default SvgGradient
